module.exports = __webpack_public_path__ + "img/follow-the-rules-eng.260397f8.png";